import React, { useContext, useEffect, useState, useRef } from "react";
import Input from "components/Elements/Input";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useAuthContext } from "../../contexts/AuthContext";
import { ConfirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";
import {
  createSupportingContentItem,
  updateSupportingContentItem,
  getSupportingContentItem,
} from "services/supportingContent";
import styled from "styled-components";
import Swal from "sweetalert2";
import {
  MDXEditor,
  headingsPlugin,
  listsPlugin,
  quotePlugin,
  thematicBreakPlugin,
  markdownShortcutPlugin,
  toolbarPlugin,
  imagePlugin,
  linkPlugin,
  linkDialogPlugin,
  tablePlugin,
  diffSourcePlugin,
  UndoRedo,
  BoldItalicUnderlineToggles,
  BlockTypeSelect,
  CreateLink,
  InsertTable,
  InsertImage,
  DiffSourceToggleWrapper,
} from "@mdxeditor/editor";
import "@mdxeditor/editor/style.css";
import { AppContext } from "../../contexts/AppContext";
import * as config from "../../config.js";

export const ErrorField = styled.span`
  color: red;
  font-size: 0.75rem;
  margin-top: 0.25rem;
`;

const ContentEditor = () => {
  const { selectedClient } = useContext(AppContext);
  const { content_id } = useParams();
  const location = useLocation();
  const supporting_content_id = location.state?.supporting_content_id;
  console.log("!!! CONTENT EDITOR: ", content_id);
  const { activeUser } = useAuthContext();
  const [saving, setSaving] = useState(false);
  const [content, setContent] = useState(null);
  const toast = useRef();
  const navigate = useNavigate();

  console.log("!! SELECTED CLIENT: ", selectedClient);
  console.log("!! CONTENT ID: ", content_id);
  console.log("!! SUPPORTING CONTENT ID: ", supporting_content_id);
  useEffect(() => {
    console.log("!!! GET CONTENT: ", content_id);
    const fetchData = async () => {
      const response = await getSupportingContentItem(content_id);
      console.log("!!! RESPONSE: ", response);
      if (response) {
        setContent(response);
      }
    };

    console.log("!!! CONTENT ID: ", content_id);
    if (content_id) {
      fetchData();
    } else {
      console.log("!!! ADDING NEW CONTENT");
      setContent({
        id: "",
        public_id: "",
        name: "",
        description: "",
        data: "",
        content_type: "blog-post",
        supporting_content_id: supporting_content_id,
      });
    }
    // eslint-disable-next-line
  }, [content_id]);

  const save = async () => {
    setSaving(true);

    if (content.public_id) {
      const response = await updateSupportingContentItem(
        content.public_id,
        content
      );

      if (response.success) {
        Swal.fire("Success", "Content saved", "success");
      }
    } else {
      const response = await createSupportingContentItem(content);

      if (response.success) {
        Swal.fire("Success", "Content saved", "success");
        const supportingContentItem = response.supporting_content_item;
        const newContent = { ...content };
        newContent.public_id = supportingContentItem.public_id;
        newContent.id = supportingContentItem.id;
        newContent.updated_at = supportingContentItem.updated_at;
        newContent.created_at = supportingContentItem.created_at;
        setContent(newContent);
      }
    }

    setSaving(false);
  };

  const handleChange = (key, value) => {
    console.log("CHANGE: ", key, value);
    const updatedContent = { ...content };
    updatedContent[key] = value;
    setContent(updatedContent);
  };

  const imageUploadHandler = async (image) => {
    if (!selectedClient?.id) {
      Swal.fire({
        title: "Error",
        text: "A client must be selected to upload images",
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }

    const clientId = selectedClient.id;
    const formData = new FormData();
    formData.append("file", image);
    console.log("UPLOAD IMAGE: ", image);
    // send the file to your server and return
    // the URL of the uploaded image in the response
    const response = await fetch(
      `${config.REST_SERVER_URL}/admin/upload/${clientId}`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
        }, credentials: "include",

        body: formData,
      }
    );
    const json = await response.json();
    console.log("!!! JSON RESPONSE: ", json);
    return json.url;
  };

  if (!content) {
    return <div>Loading Content...</div>;
  }

  const SaveButton = () => {
    if (!activeUser || activeUser.user_type !== "admin") {
      return null;
    }

    return (
      <div>
        <div className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
          <button
            className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
            type="button"
            onClick={save}
            disabled={saving}
          >
            {saving ? (
              <>
                <i className="fas fa-circle-notch fa-spin"></i> Saving...
              </>
            ) : (
              <>Save</>
            )}
          </button>
        </div>
      </div>
    );
  };
  return (
    <>
      <div className="relative" style={{ height: "100%", minHeight: "100vh" }}>
        <div className="px-4 md:px-6 mx-auto w-full -mt-24 pt-8">
          <div className="flex flex-wrap">
            <div className="relative p-6 flex-auto ">
              <div>
                <div
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    navigate(
                      `/client/supporting-content-items/${content.supporting_content_id}`
                    )
                  }
                >
                  <i className="fa fa-arrow-left" /> Back to Content Items
                </div>
              </div>
              <div style={{ fontSize: "32px", fontWeight: "bold" }}>
                {content.name ?? ""}
              </div>
              <div
                className="my-4 text-blueGray-500 text-lg leading-relaxed"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "wrap",
                }}
              >
                <div
                  style={{ width: "40%", flexShrink: 0, marginRight: "20px" }}
                >
                  <label>ID</label>
                  <Input
                    label="ID"
                    placeholder="ID"
                    name="id"
                    value={content.id ?? ""}
                    disabled
                  />
                </div>
                <div
                  style={{ width: "40%", flexShrink: 0, marginRight: "20px" }}
                >
                  <label>Public ID</label>
                  <Input
                    label="Public ID"
                    placeholder="Public ID"
                    name="public_id"
                    value={content.public_id ?? ""}
                    disabled
                  />
                </div>
                <div
                  style={{ width: "40%", flexShrink: 0, marginRight: "20px" }}
                >
                  <label>Title</label>
                  <Input
                    label="Title"
                    placeholder="Title"
                    name="title"
                    value={content.name ?? ""}
                    onChange={(e) => handleChange("name", e.target.value)}
                  />
                </div>
                <div
                  style={{ width: "40%", flexShrink: 0, marginRight: "20px" }}
                >
                  <label>Description</label>
                  <Input
                    type="textarea"
                    label="Description"
                    placeholder="Description"
                    name="description"
                    value={content.description ?? ""}
                    onChange={(e) =>
                      handleChange("description", e.target.value)
                    }
                  />
                </div>
              </div>
              <SaveButton />
              <div className="relative flex-auto overflow-y-auto overflow-visible">
                <div className="my-4 text-blueGray-500 text-lg leading-relaxed overflow-y-auto overflow-visible">
                  <div
                    style={{
                      overflow: "auto",
                      borderRadius: "5px",
                      borderWidth: "1px",
                      borderStyle: "solid",
                      borderColor: "rgb(203, 213, 225)",
                      maxHeight: "1000px",
                      minHeight: "500px",
                    }}
                  >
                    <MDXEditor
                      markdown={content.data}
                      onChange={(value) => handleChange("data", value)}
                      plugins={[
                        headingsPlugin(),
                        listsPlugin(),
                        linkPlugin(),
                        linkDialogPlugin(),
                        tablePlugin(),
                        quotePlugin(),
                        thematicBreakPlugin(),
                        imagePlugin({ imageUploadHandler }),
                        markdownShortcutPlugin(),
                        diffSourcePlugin(),
                        toolbarPlugin({
                          toolbarContents: () => (
                            <>
                              <UndoRedo />
                              <BoldItalicUnderlineToggles />
                              <BlockTypeSelect />
                              <CreateLink />
                              <InsertImage />
                              <InsertTable />
                              <DiffSourceToggleWrapper />
                            </>
                          ),
                        }),
                      ]}
                    />
                  </div>
                </div>
              </div>
              <SaveButton />
              <Toast ref={toast} />
              <ConfirmDialog />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContentEditor;
